/** Gerente (#284) entra em tudo do restaurante; plano/assinatura ficam só no Dono. */
export const MANAGER_ROLES = ['manager', 'restaurant_owner', 'platform_owner']
/** Operação: o Gerente (#284) entra onde o dono opera o salão/cozinha. */
export const OPERATIONS_ROLES = MANAGER_ROLES
export const KITCHEN_ROUTE_ROLES = ['kitchen', ...OPERATIONS_ROLES]
export const WAITER_ROUTE_ROLES = ['waiter', ...OPERATIONS_ROLES]
export const PLATFORM_ROLES = ['platform_owner']
